import React from "react";
import logo from "../assets/images/tks_modern_logo.svg";
import { LocationOn, Email, Phone } from "@mui/icons-material";
import {
  Box,
} from "@mui/material";

function Footer() {
  const footerBgStyle = {
    background: "linear-gradient(to bottom right, #ffffff, #FFF9C4, #FDF5A6)",
  };

  return (
    <>
      {/* Footer Main Section */}
      <div
        className="relative text-black py-4 px-4 md:px-8 overflow-hidden custom-footer-bg"
        style={footerBgStyle}
      >
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-start gap-4 text-sm">
          {/* Left Section - Logo & Description */}
          <div className="w-full md:w-1/3 flex flex-col items-start text-left">
            <div className="flex items-center gap-2 mb-2 cursor-pointer" onClick={() => (window.location.href = "/")}>
              <img
                src={logo}
                alt="Temple Logo"
                className="w-28 h-auto object-contain"
              />
              <Box sx={{ color: '#E52029', fontWeight: 600, textAlign: 'left', fontSize: "16px" }}>
                <div>திருக்கடையூர்</div>
                <div>சேனைத்தலைவர்</div>
                <div>அறக்கட்டளை</div>
              </Box>
            </div>
            <p className="text-xs leading-snug max-w-xs">
              Join us in our mission to uplift and serve the community with compassion and purpose.
            </p>
          </div>

          {/* Middle Section - Quick Links */}
          <div className="w-full md:w-1/3 flex flex-col items-start text-left">
            <h3 className="font-semibold text-base mb-2 text-gray-900">Quick Links</h3>
            <ul className="space-y-1.5 text-sm">
              <li><a href="/#contact-section" className="hover:text-red-500">Contact Us</a></li>
              <li><a href="/terms" className="hover:text-red-500">Terms & Conditions</a></li>
              <li><a href="/privacy" className="hover:text-red-500">Privacy Policy</a></li>
              <li><a href="/#faq-section" className="hover:text-red-500">FAQ</a></li>
            </ul>
          </div>

          {/* Right Section - Contact Information */}
          <div className="w-full md:w-1/3 flex flex-col items-start text-left">
            <h3 className="font-semibold text-base mb-2 text-gray-900">Contact Us</h3>
            <p className="flex items-center mt-1"><LocationOn className="text-red-500 mr-1" />Project Office, Chennai. </p>
            <p className="flex items-center mt-1">
              <Email className="text-red-500 mr-1" />
              <a href="mailto:contact@tkstrust.com" className="hover:underline text-sm">contact@tkstrust.com</a>
            </p>
            <p className="flex items-center mt-1"><Phone className="text-red-500 mr-1" /> +91 9841818740</p>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <footer className="bg-[#FAD707] text-black p-2 text-center text-xs">
        <div className="container mx-auto">
          <span>©2025 Thirukadaiyur Senaithalaivar Charitable Trust. All Rights Reserved.</span>
        </div>
      </footer>
    </>
  );
}

export default Footer;
